// extracted by mini-css-extract-plugin
export default {"container":"CompareSubmission_container__4bG03"};